import InfoPanel from "@rui/InfoPanel";
import { Link } from "@rui/Link";

const ReauthorizationAlert = ({
  onClickReauthorize,
}: {
  onClickReauthorize: () => void;
}) => (
  <InfoPanel severity="error" sx={{ mt: 2, width: "100%" }} direction="column">
    Reauthorization required.{" "}
    <Link fontWeight={500} onClick={onClickReauthorize}>
      Click to reauthorize
    </Link>
    .
  </InfoPanel>
);

export default ReauthorizationAlert;
